import React, { Component } from "react";
import PropTypes from 'prop-types';
import Comments from "../Articles/Comments"
import PostDeckComment from "./PostDeckComment"
import { db, firebase } from '../firebase';


class DeckComments extends Component {

  render() {

    var buttonStyle={
      marginTop: 10
    }

    var loginStyle = {
      marginTop: 20,
      backgroundColor: "white",
      marginBottom: 20
    };

    var h2Style = {
      paddingLeft: 10,
      paddingTop: 5,
      fontFamily: "Audiowide, cursive",
      color: "cadetblue"
    };

    return (
      <div style={loginStyle}  className="container rounded">
      <h2 style={h2Style}>Comments</h2>
        <Comments comments={this.props.comments} />
        <PostDeckComment postHandler={this.props.postHandler} comments={this.props.comments} authUserId={this.context.authUserId} deckId={this.props.deckId} userName={this.context.userName} inGameName={this.context.inGameName} />
      </div>
    );

  }
}

DeckComments.contextTypes = {
  authUser: PropTypes.object,
  userName: PropTypes.string,
  inGameName: PropTypes.string,
  authUserId: PropTypes.string
};


export default DeckComments;



// WEBPACK FOOTER //
// ./src/DBV2/DeckComments.js